import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    // transform(values: string, args): SafeHtml {
    //     // Check if values or args is not defined, and return empty array or values accordingly
    //     if (!values) { return []; }
    //     if (!args) { return values; }

    //     // Replace occurrences of args (case-insensitive) with a highlighted span
    //     const value:string = values.toString().replace(
    //         new RegExp(args, 'g'),
    //         `<span style='background-color:yellow;padding:1px;'>$&</span>`
    //     ).replace(
    //         new RegExp(args.toUpperCase(), 'g'),
    //         `<span style='background-color:yellow;padding:1px;'>$&</span>`
    //     );

    //     // Bypass security and return the transformed value as SafeHtml
    //     return this._sanitizer.bypassSecurityTrustHtml(value);
    // }
    transform(values: string, args): SafeHtml {
        // Check if values or args is not defined, and return empty string or values accordingly
        if (!values) { return ''; }
        if (!args) { return values; }

        // Replace occurrences of args (case-insensitive) with a highlighted span
        const highlightedValue: string = values.toString().replace(
            new RegExp(this.escapeRegExp(args), 'gi'),
            `<span style='background-color:yellow;padding:1px;'>$&</span>`
        );

        // Sanitize the highlighted value before returning it
        const sanitizedValue: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(highlightedValue);
        return sanitizedValue;
    }

    // Function to escape special characters in the search term
    escapeRegExp(term: string): string {
        return term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    
}
